import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.ProvenExpertWidget = function(element, consent) {
        this.$wrapper = $(element);
        this.$image = $('img', this.$wrapper);
        this.consent = consent;

        this.init();
    };

    OndigoNS.ProvenExpertWidget.prototype = {
        init: function () {
            if(OndigoNS.Usercentrics.provenExpertAllowed(this.consent)) {
                this.loadProvenExpert(true);
            } else if (OndigoNS.Utils.isGoogleBot()){
                var proven_script = document.createElement('script');
                proven_script.setAttribute('src','https://www.provenexpert.com/widget/richsnippet.js?u=1NKAlRaAmDQA0xQAmLwZlA3ZkRwA4xQA&v=2');
                document.head.appendChild(proven_script);
            } else {
                this.loadProvenExpert(false);
            }
        },

        loadProvenExpert: function (init) {
            if(init) {
                if(this.$wrapper.data('init') !== '1') {
                    this.$image.attr('src', this.$image.data('src'));
                    this.$wrapper.data('init', '1');
                }

                OndigoNS.Usercentrics.provenExpertRemoveOverlay(this.$wrapper, this.consent);
            } else {
                this.$image.attr('src', '/loadDummy.png');
                this.$wrapper.data('init', '');
                OndigoNS.Usercentrics.provenExpertShowOverlay(this.$wrapper, this.consent);
            }
        }
    };

    // plugin definition
    $.fn.provenExpertWidget = function (e) {
        return new OndigoNS.ProvenExpertWidget(this, e);
    };
    $.fn.provenExpertWidget.Constructor = OndigoNS.ProvenExpertWidget;

}(window.jQuery));


$(document).ready(function () {
    'use strict';

    var $wrapper = $('.proven-expert-wrapper');

    if($wrapper.length) {
        $.each($wrapper, function () {
            $(this).provenExpertWidget(false);
        });
    }

    window.addEventListener('ucEvent', function (e) {

        if($wrapper.length) {
            $.each($wrapper, function () {
                $(this).provenExpertWidget(e);
            });
        }
    });
});
